export const buildRightsFromMenu = (
    menuConfig
) => {

    const permissionMap = new Map();

    const addPermission = (
        permission,
        title
    ) => {

        if (!permission) return;

        if (!permissionMap.has(permission)) {
            permissionMap.set(
                permission,
                []
            );
        }

        const titles =
            permissionMap.get(
                permission
            );

        if (!titles.includes(title)) {
            titles.push(title);
        }
    };

    const walkMenu = (items = []) => {

        items.forEach((item) => {

            const children =
                item.children || [];

            const childrenHavePermissions =
                children.some(
                    (child) =>
                        child.permission
                );

            // ------------------------------------------------
            // Child permissions take priority
            // ------------------------------------------------

            if (
                children.length &&
                childrenHavePermissions
            ) {

                walkMenu(children);

                return;
            }

            // ------------------------------------------------
            // Parent permission
            // ------------------------------------------------

            if (item.permission) {

                const permissions =
                    Array.isArray(
                        item.permission
                    )
                        ? item.permission
                        : [item.permission];

                permissions.forEach(
                    (permission) => {

                        addPermission(
                            permission,
                            item.title
                        );
                    }
                );
            }

            // ------------------------------------------------
            // Children without parent permission
            // ------------------------------------------------

            if (
                children.length &&
                !item.permission
            ) {

                walkMenu(children);
            }
        });
    };

    walkMenu(menuConfig);

    return Array
        .from(permissionMap.entries())
        .map(
            ([code, titles]) => ({
                code,
                titles,
            })
        );
};